import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import SuspenseLoader from 'src/components/SuspenseLoader';
import About from './content/applications/views/about/About';
import TermsOfUse from './content/applications/views/Terms/TermsOfUse';
import PrivacyPolicy from './content/applications/views/privacy/PrivacyPolicy';
import PageMeta, { PAGE_META } from 'src/components/Seo/PageMeta';

const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const GoogleAuthSuccess = Loader(lazy(() => import('src/content/applications/Sign in/GoogleAuthSuccess')));

const Signin = Loader(lazy(() => import('src/content/applications/Sign in/SignIn')));
const Signup = Loader(lazy(() => import('src/content/applications/signup/Signup')));
const ForgotPassword = Loader(lazy(() => import('src/content/applications/Sign in/forgotPassword/ForgotPassword')));
const ResetPassword = Loader(lazy(() => import('src/content/applications/Sign in/forgotPassword/ResetPassword')));
const GoogleCallback = Loader(lazy(() => import('src/content/applications/auth/GoogleCallback')));
const GoogleSuccess = Loader(lazy(() => import('src/content/applications/auth/GoogleSuccess')));
const Company = Loader(lazy(() => import('src/content/applications/company/index')));
const Claims = Loader(lazy(() => import('src/content/applications/claims/index')));
const Favourites = Loader(lazy(() => import('src/content/applications/favourites/index')));
const Tasks = Loader(lazy(() => import('src/content/dashboards/Tasks')));
const CompanyList = Loader(lazy(() => import('src/content/dashboards/CompanyList')));
const BestDealsPage = Loader(lazy(() => import('src/content/dashboards/BestDeals')));
const Messenger = Loader(lazy(() => import('src/content/applications/Messenger')));
const Transactions = Loader(lazy(() => import('src/content/applications/Transactions')));
const Map = Loader(lazy(() => import('src/content/applications/map')));
const UserProfile = Loader(lazy(() => import('src/content/applications/Users/profile')));
const UserSettings = Loader(lazy(() => import('src/content/applications/Users/settings')));
const Status404 = Loader(lazy(() => import('src/content/pages/Status/Status404')));
const Status500 = Loader(lazy(() => import('src/content/pages/Status/Status500')));
const StatusComingSoon = Loader(lazy(() => import('src/content/pages/Status/ComingSoon')));
const StatusMaintenance = Loader(lazy(() => import('src/content/pages/Status/Maintenance')));

const routes = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      { path: 'auth/google/success', element: <PageMeta {...PAGE_META.privateArea}><GoogleAuthSuccess /></PageMeta> },

      { path: '/', element: <PageMeta {...PAGE_META.home}><Signin /></PageMeta> },
      { path: 'signin', element: <PageMeta {...PAGE_META.home}><Signin /></PageMeta> },
      { path: 'Signup', element: <PageMeta {...PAGE_META.signup}><Signup /></PageMeta> },
      { path: 'ForgotPassword', element: <PageMeta {...PAGE_META.forgotPassword}><ForgotPassword /></PageMeta> },
      { path: 'ResetPassword', element: <PageMeta {...PAGE_META.resetPassword}><ResetPassword /></PageMeta> },
      { path: 'about', element: <PageMeta {...PAGE_META.about}><About /></PageMeta> },
      { path: 'terms', element: <PageMeta {...PAGE_META.terms}><TermsOfUse /></PageMeta> },
      { path: 'privacy', element: <PageMeta {...PAGE_META.privacy}><PrivacyPolicy /></PageMeta> },
      {
        path: 'status',
        children: [
          { path: '', element: <Navigate to="404" replace /> },
          { path: '404', element: <PageMeta {...PAGE_META.privateArea}><Status404 /></PageMeta> },
          { path: '500', element: <Status500 /> },
          { path: 'maintenance', element: <StatusMaintenance /> },
          { path: 'coming-soon', element: <StatusComingSoon /> }
        ]
      },
      { path: '*', element: <PageMeta {...PAGE_META.privateArea}><Status404 /></PageMeta> }
    ]
  },
  {
    path: 'dashboards',
    element: <PageMeta {...PAGE_META.privateArea}><SidebarLayout /></PageMeta>,
    children: [
      { path: '', element: <Navigate to="home" replace /> },
      { path: 'home', element: <Tasks /> },
      { path: 'map', element: <Map /> },
      { path: 'messenger', element: <Messenger /> },
      { path: 'company/:id', element: <Company /> },
      { path: 'companies/country/:country', element: <CompanyList /> },
      { path: 'companies/business-area/:businessAreaId', element: <CompanyList /> },
      { path: 'best-deals/:scope', element: <BestDealsPage /> },
      { path: 'claims', element: <Claims /> },
      { path: 'Favourites', element: <Favourites /> }
    ]
  },
  {
    path: 'profil',
    element: <PageMeta {...PAGE_META.privateArea}><SidebarLayout /></PageMeta>,
    children: [{ path: '', element: <UserSettings /> }]
  },
  {
    path: 'management',
    element: <PageMeta {...PAGE_META.privateArea}><SidebarLayout /></PageMeta>,
    children: [{ path: '', element: <Navigate to="transactions" replace /> }]
  }
];

export default routes;